import { useQuery } from '@tanstack/react-query';
import { API } from 'src/shared/api';

const QUERY_ROOT = 'tree-view';
const QUERY_ATTEMPTS = 1;
const DOCUMENTS_STALE_TIME = 5 * 60 * 1000;

const useTreeViewQuery = () => {
  const listContentIndex = (spaceId: string, articleId?: string) =>
    useQuery({
      queryKey: [QUERY_ROOT, 'index', spaceId, articleId],
      queryFn: ({ signal }) =>
        API.Atlassian.listProjectIndex({ spaceId, articleId }, { signal })
          .response,
      retry: QUERY_ATTEMPTS,
      staleTime: DOCUMENTS_STALE_TIME
    });

  return {
    listContentIndex
  };
};

export default useTreeViewQuery;
